module.exports = __webpack_public_path__ + "img/nike.08f808da.png";